/* eslint-disable react/prop-types */

import React from 'react';
import { Gray } from 'constants/colors';

import { Icon } from '../../icon';
import { Text } from '../../text';
import LoadingSpin from '../../loadingSpin';

import { ButtonWithIconStyle } from './style';

export default function ButtonWithIcon({
  title,
  onClick,
  formId = '',
  icon,
  loading = false,
  customTextColor = '#fff',
  customIconColor = '#fff',
  customBackgroundColor = '#192379',
  customDisabledBackgroundColor = Gray[200],
  disabled = false,
  iconPosition = 'right',
  iconOptions = {},
  textOptions = {},
  ...option
}) {
  const isDisabled = disabled || loading;

  return (
    <ButtonWithIconStyle
      onClick={onClick}
      backgroundColor={isDisabled ? customDisabledBackgroundColor : customBackgroundColor}
      form={formId}
      width="auto"
      disabled={isDisabled}
      {...option}
    >
      {iconPosition === 'left' && (
        <Icon
          icon={icon}
          width="14px"
          height="14px"
          color={customIconColor}
          {...iconOptions}
        />
      )}
      {title && (
        <Text
          cursor="pointer"
          fontWeight="500"
          fontSize="13px"
          lineHeight="15px"
          color={isDisabled ? Gray[400] : customTextColor}
          marginLeft={iconPosition === 'left' && '10px'}
          marginRight={iconPosition === 'right' && '10px'}
          {...textOptions}
        >
          {title}
        </Text>
      )}
      {iconPosition === 'right' && (
        loading ? (
          <LoadingSpin
            show
            size="14px"
            weight="2px"
            backColor={Gray[400]}
            frontColor="transparent"
          />
        ) : (
          <Icon
            icon={icon}
            width="14px"
            height="14px"
            color={isDisabled ? Gray[400] : customIconColor}
            {...iconOptions}
          />
        )
      )}
    </ButtonWithIconStyle>
  );
}
